/**
 * Helper component for rendering basic slider inputs (styled checkbox inputs)
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

const SliderInput = ({
  change
  , disabled
  // , helpText // TODO: add help text maybe?
  , label
  , name
  , value = false
}) => {
  return (
    <div className="flex flex-row">
      <label className="relative group flex py-2 text-sm">
        <input className="sr-only peer"
          checked={!!value}
          disabled={disabled}
          type="checkbox" 
          onChange={e => {
            change({
              target: {
                name: name
                , value: e.target.checked
              }
            })
          }} 
        />
        <span className={`${disabled ? 'peer-checked:bg-brand-sec cursor-not-allowed' : 'group-hover:after:translate-x-1 peer-checked:bg-info-con'} w-12 h-6 flex p-1 bg-neutral-ter rounded-full duration-300 ease-in-out after:w-4 after:h-4 after:bg-neutral-pri after:rounded-full after:shadow-md after:duration-300 peer-checked:after:translate-x-6`}></span>
      </label>
      { label ? 
        <div className="flex flex-col justify-center p-2 text-sm ">
          <p className={disabled ? "text-neutral-sec" : "text-neutral-pri"}>{label}</p>
        </div>
      : null
      }
    </div>
  )
}

SliderInput.propTypes = {
  change: PropTypes.func.isRequired
  , disabled: PropTypes.bool
  // , helpText: PropTypes.any
  , label: PropTypes.string
  , name: PropTypes.string
  , value: PropTypes.bool
}

SliderInput.defaultProps = {
  disabled: false
  // , helpText: null
  , label: ''
}

export default SliderInput;
